import { takeLatest, put } from 'redux-saga/effects';
import moment from 'moment';

import { storage } from '@commons/storage';

import {
  CONFIG_SESSION,
  transferenciaAnimal,
  NEW_TRANSFERENCIA_ANIMAL,
  NEW_TRANSFERENCIA_ANIMAL_SUCCESS,
} from '@handler';

function* sagaNewTransferenciaAnimal(action) {

  yield put({ type: NEW_TRANSFERENCIA_ANIMAL_SUCCESS, registro: 
    {
      ...transferenciaAnimal.newRegistro,
      data: moment().startOf('day').format('YYYY-MM-DD'),
      anoPecuario: JSON.parse(storage.get(CONFIG_SESSION)).anoPecuarioAtivo,
    } });
}

export default function* watchNewTransferenciaAnimal() {
  yield takeLatest(NEW_TRANSFERENCIA_ANIMAL, sagaNewTransferenciaAnimal)
}
